class APIS {
	apis() {
		return {
			// Connected TikTok accounts for the client (used on /channels/TikTok
			// and to gate the TikTok tab inside the inbox).
			accountsGetAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tiktok/accounts/get-all'
			},
			// Returns the TikTok OAuth authorize URL to open when connecting a
			// new TikTok account (used on the /channels "Connect" button).
			authUrl: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tiktok/auth-url'
			},
			// Soft-disconnects a connected TikTok account (used on the /channels
			// "delete" icon).
			disconnectAccount: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tiktok/accounts/disconnect'
			},
			// Conversation (ticket) list for the TikTok inbox sidebar.
			conversationsGetAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tiktok/conversations/get-all'
			},
			// Messages of a single TikTok conversation.
			messagesGetAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tiktok/messages/get-all'
			},
			// Send a message (TEXT / IMAGE / TEMPLATE / SENDER_ACTION).
			// NOTE: the path intentionally has no trailing slash after "send" so it is
			// NOT re-routed to the socket endpoint by CoreHttpHandler (which only matches
			// "/messages/send/").
			messagesSend: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tiktok/messages/send'
			},
			// Upload an image before sending it. conversationId is passed as a query
			// param via the :conversationId placeholder; the file goes in a FormData body.
			mediaUpload: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tiktok/messages/media/upload?conversationId=:conversationId'
			}
		};
	}
}

export default new APIS();
